class A_Or_B {
    static path = 'logic/or';

    constructor(mutator){
        this.addInput("Condition A", "boolean");
        this.addInput("Condition B", "boolean");
        this.addOutput("true/false", "boolean");
        this.bgcolor = '#70d3ef';
        this.title = 'If A or B ...';
        this.desc = 'Conditional Branch';
    }
}

module.exports = A_Or_B
